<div class="container mx-auto p-6">
  <div class="flex justify-between items-center mb-6">
    <div>
      <h1 class="text-2xl font-semibold text-gray-800 dark:text-white/90">
        {{ product?.name }}
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        Product Daily Prices
      </p>
    </div>
    <app-button
      [label]="'Back to Product'"
      [icon]="BackIcon"
      [style]="'secondary'"
      [routerLink]="['/products', product?.id, 'edit']">
    </app-button>
  </div>

  <!-- Bulk Update Form -->
  <div class="mb-6">
    <app-daily-pricing-bulk-update
      [storeBulkDailyPrices]="storeBulkDailyPrices"
      [deleteBulkDailyPrices]="deleteBulkDailyPrices"
      (onSuccess)="onBulkUpdateSuccess()">
    </app-daily-pricing-bulk-update>
  </div>

  <!-- Calendar View with Overview -->
  <app-daily-pricing-calendar
    [getDailyPrices]="getDailyPrices"
    (onPriceClick)="onPriceClick($event)">
  </app-daily-pricing-calendar>
</div>
